import DocOCR from "@tecnike/dococr";
import Cliente from "@/entities/cliente";
import { TipoCliente } from "@/entities/tipo-cliente";

import CodiceFiscale from "codice-fiscale-js";
import Residenza from "@/entities/Residenza";

const getReadingsByKey = function (result: DocOCR.DocOCRResult, keys: Array<string>): Array<DocOCR.OCRReading> {
  const array: Array<DocOCR.OCRReading> = [];

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const eligibleDocuments = result.res.filter(item => Object.keys(item).includes(key));
    if (eligibleDocuments.length > 0) {
      const eligibleReadings = eligibleDocuments.map(item => {
        const record = item as unknown as Record<string, DocOCR.OCRReading>;
        return record[key];
      });

      const readings = eligibleReadings.filter(item => !!item);
      array.push(...readings);
    }
  }

  return array;
};

const getBestValue = function (readings: Array<DocOCR.OCRReading>): string {
  if (readings.length === 0) {
    return "";
  }

  let bestReading = readings[0];
  for (let i = 1; i < readings.length; i++) {
    const reading = readings[i];
    if (reading.confidence > bestReading.confidence) {
      bestReading = reading;
    }
  }

  return bestReading.text;
};

export default {
  processResult (result: DocOCR.DocOCRResult): Cliente {
    // Estraggo le proprietà da tutti i documenti possibili, preferendo
    // quello con confidenza maggiore, laddove non sia possibile effettuare
    // ulteriori test sul dato (e.g.: codice fiscale, data di nascita tramite regex).

    const sessoReadings = getReadingsByKey(result, ["sesso"]);
    const sessoLetter = getBestValue(sessoReadings);

    let sesso: TipoCliente = "Maschio";
    if (sessoLetter === "M") {
      sesso = "Maschio";
    } else if (sessoLetter === "F") {
      sesso = "Femmina";
    }

    const cognomeReadings = getReadingsByKey(result, ["cognome"]);
    const cognome = getBestValue(cognomeReadings);

    const nomeReadings = getReadingsByKey(result, ["nome"]);
    const nome = getBestValue(nomeReadings);

    const codiceFiscaleReadings = getReadingsByKey(result, ["codiceFiscale"]);
    let codiceFiscale = getBestValue(codiceFiscaleReadings);

    // Per luogo di nascita e data di nascita dipende dai documenti la lettura.
    let luogoNascita = "";
    let dataNascita = "";

    const luogoDataNascitaReadings = getReadingsByKey(result, ["luogoDataNascita"]);
    const luogoDataNascita = getBestValue(luogoDataNascitaReadings);
    if (luogoDataNascita) {
      // Cerco di estrarre la data di nascita dalla stringa.
      const dataNascitaResult = new RegExp("\\d\\d\\.\\d\\d\\.\\d\\d\\d\\d").exec(luogoDataNascita);
      if (dataNascitaResult) {
        const dataNascitaRaw = dataNascitaResult[0];
        const luogoNascitaDirty = luogoDataNascita.replace(dataNascitaRaw, "").trim();

        dataNascita = dataNascitaRaw.replace(new RegExp("[^\\d]", "g"), "/");
        luogoNascita = luogoNascitaDirty;
      }
    }

    // Controlli vari riguardanti il codice fiscale.
    try {
      const decodedCodiceFiscale = new CodiceFiscale(codiceFiscale);
    } catch {
      codiceFiscale = "";
    }

    // TODO: L'indirizzo diventa parecchio complesso..
    const indirizzoReadings = getReadingsByKey(result, ["indirizzo"]);
    const indirizzoValue = getBestValue(indirizzoReadings);

    // Do per scontato che l'indirizzo arrivi col formato
    // del resto della carta d'identità (che potrebbe non essere standard),
    // e che il toponimo sia lungo una parola sola (per quanto ce ne siano
    // anche di due o tre parole, andrebbe però fatto un'array con tutti i valori
    // possibili, tipo...).
    const residenza: Residenza = {
      cap: "",
      comune: "",
      indirizzo: "",
      numeroCivico: "",
      provincia: "",
      toponimo: "VIA",
      nazione: "ITALIA"
    };

    const regexIndirizzo = new RegExp("^(?<toponimo>\\w+) (?<indirizzo>.+), (?<numeroCivico>.+?) (?<comune>.+?) \\((?<provincia>\\w+)\\)$");
    const matchesIndirizzo = regexIndirizzo.exec(indirizzoValue);
    if (matchesIndirizzo && matchesIndirizzo.groups) {
      residenza.comune = matchesIndirizzo.groups.comune;
      residenza.indirizzo = matchesIndirizzo.groups.indirizzo;
      residenza.numeroCivico = matchesIndirizzo.groups.numeroCivico;
      residenza.provincia = matchesIndirizzo.groups.provincia;
      residenza.toponimo = matchesIndirizzo.groups.toponimo;
    }

    return {
      tipo: sesso || "Maschio",
      cognome: cognome,
      nome: nome,
      codiceFiscale: codiceFiscale,
      dataNascita: dataNascita,
      luogoNascita: luogoNascita,
      note: "",
      partitaIva: "",
      recapiti: {
        cellulare: "",
        email: "",
        telefonoFisso: ""
      },
      residenza: residenza
    };
  }
};
